import React from 'react';
import { ConfirmationModal, ModalActionTypes } from '@acorns/web-components';

var ErrorModal = function ErrorModal(_ref) {
  var onBack = _ref.onBack,
      onClose = _ref.onClose,
      show = _ref.show;
  return /*#__PURE__*/React.createElement(ConfirmationModal, {
    isOpen: show,
    title: "Error",
    message: "Wrong username/password or verification code",
    onRequestClose: onClose,
    actions: [{
      label: 'Back',
      type: ModalActionTypes.danger,
      handler: onBack
    }],
    isTrapModal: true
  });
};

export { ErrorModal };